export default "__VITE_PUBLIC_ASSET__833bf932__"